import { render, staticRenderFns } from "./AdvCartGiftList.vue?vue&type=template&id=2da7628a&"
import script from "./AdvCartGiftList.vue?vue&type=script&lang=js&"
export * from "./AdvCartGiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports